export default "__VITE_PUBLIC_ASSET__6b5e9065__"